import PageLayout from "../../../../../components/page/PageLayout";
import DeactivateLayout from "../../../account/layout/settings/DeactivateLayout";

const PageDeactivate = () => {

    return (
        <PageLayout requireSignIn>
            <DeactivateLayout />
        </PageLayout>
    );

}

export default PageDeactivate;
